/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    fullWidth: {
      description: 'Makes cards always occupy the full width of the parent, regardless of viewport',
      type: 'variant',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: { direction: 'row', space: 6 }
    },
    {
      if: { fullWidth: true },
      tokens: { direction: 'column', fieldSpace: 4, space: 4 }
    }
  ],
  tokens: {
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    direction: 'column',
    fieldSpace: 4,
    outlineOffset: 8,
    outlineWidth: 1,
    showIcon: true,
    space: 4
  }
}
export default theme
